import { makeAutoObservable } from 'mobx';

class FeaturePermissionViewModel {
  featurePermission;

  constructor(featurePermission) {
    makeAutoObservable(this);

    this.featurePermission = featurePermission;
  }

  set checked(value) {
    this.featurePermission.enabled = value;
  }

  toggle() {
    this.featurePermission.toggle();
  }

  get checked() {
    return this.featurePermission.enabled;
  }

  get isReportPermission() {
    return this.featurePermission.group === 'reports';
  }
}

export default FeaturePermissionViewModel;
